/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import {
  NDC_DETAILS_ALTERNATE_THERAPEUTIC_TABLEHEAD,
  NDC_DETAILS_THERAPEUTIC_TABLEHEAD,
} from '../../../utility/tableHeads';
import DisplayFamilyPlanning from './DisplayFamilyPlanning';
import TabNDCDetailsInputContainer from './TabNDCDetailsInputContainer';
import TabNDCDetailsTableComponent from './TabNDCDetailsTableComponent';

const TabNDCDetail = (props) => {
  const { fullScreen, setFullScreen } = props;
  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );
  const referenceData = useSelector(
    (state) => state.sharedState.ndc.referenceData
  );
  const generalSystemParameterDetails = useSelector(
    (state) => state?.sharedState?.ndc?.generalSystemParameter?.paramGeneralVO
  );

  const [familyPlanning, setFamilyPlanning] = useState({
    open: false,
    data: [],
  });

  const handleCloseFamilyPlanning = () => {
    setFamilyPlanning({ open: false, data: [] });
  };

  const getDescValueFromReferenceData = (inputValue) => {
    if (inputValue) {
      const index = referenceData.SPEC_THERA_CLASS_CD.findIndex(
        (item) =>
          item.codeValueID.codeDomainKey === 'SPEC_THERA_CLASS_CD' &&
          item.codeValueID.codeValue === inputValue
      );
      if (index !== -1) {
        return referenceData.SPEC_THERA_CLASS_CD[index].longDescription;
      }
      return '<description not found>';
    }
    return '<description not found>';
  };

  const [therapeutic, setTherapeutic] = useState([]);
  const [altTherapeutic, setAltTherapeutic] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [fullScreenViewAlt, setFullScreenViewAlt] = useState(false);
  const [gridDisplayMatrix, setGridDisplayMatrix] = useState({
    LTGridDisplay: true,
    grid1Display: true,
    grid2Display: true,
  });
  useEffect(() => {
    if (fullScreen == false) {
      setGridDisplayMatrix({
        LTGridDisplay: true,
        grid1Display: true,
        grid2Display: true,
      });
    }
  }, [fullScreen]);
  const handleFullScreenGird1 = () => {
    setGridDisplayMatrix({
      LTGridDisplay: false,
      grid1Display: true,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  const handleFullScreenGird2 = () => {
    setGridDisplayMatrix({
      LTGridDisplay: false,
      grid1Display: true,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  const handleLTGridFullScree = () => {
    setGridDisplayMatrix({
      LTGridDisplay: true,
      grid1Display: false,
      grid2Display: false,
    });
    setFullScreen(!fullScreen);
  };
  const manageFullScreenAlt = (val) => {
    setFullScreen(!fullScreen);
  };
  const manageFullScreen = (val) => {
    setFullScreen(!fullScreen);
  };
  useEffect(() => {
    // setTimeout(() => {
      if (
        currentNDCDetailsSelected &&
        currentNDCDetailsSelected.drugSpecTheraClassVOs
      ) {
        const data = currentNDCDetailsSelected.drugSpecTheraClassVOs.map(
          (item) => {
            return {
              ...item,
              longDescr:
                item.drugSpecTheraClassIdVO &&
                item.drugSpecTheraClassIdVO?.specTheraClassCd
                  ? getDescValueFromReferenceData(
                      item.drugSpecTheraClassIdVO?.specTheraClassCd
                    )
                  : null,
            };
          }
        );
        setTherapeutic(data);
        setAltTherapeutic(data.filter((item) => item.altTc !== null));
      } else {
        setTherapeutic([]);
        setAltTherapeutic([]);
      }
    // }, 500);
  }, [
    currentNDCDetailsSelected &&
      currentNDCDetailsSelected?.drugSpecTheraClassVOs,
  ]);

  return (
    <>
      <div className="row align-items-center tab-ndc-details">
        {!fullScreen ? (
          <>
            <TabNDCDetailsInputContainer
              referenceData={referenceData}
              details={
                (currentNDCDetailsSelected &&
                  currentNDCDetailsSelected.drugDetailVOs) ||
                null
              }
            />
            <div className="col-12 mt-3 d-flex justify-content-end align-items-center">
              <Button
                className="btn btn-success"
                disabled={
                  !(
                    currentNDCDetailsSelected &&
                    currentNDCDetailsSelected.drugDetailVOs &&
                    currentNDCDetailsSelected.drugDetailVOs
                      .familyPlanningInd === 1
                  )
                }
                onClick={() =>
                  setFamilyPlanning({
                    open: true,
                    data:
                      (currentNDCDetailsSelected &&
                        currentNDCDetailsSelected.rpcDrugFamilyPlanningVOs) ||
                      [],
                  })
                }
              >
                Display Family Planning
              </Button>
            </div>{' '}
          </>
        ) : null}
        <>
          {gridDisplayMatrix.grid1Display && (
            <>
              {!fullScreen && (
                <span className="mt-3 col-12">Therapeutic Class</span>
              )}
              <TabNDCDetailsTableComponent
                tableData={therapeutic}
                tableHead={NDC_DETAILS_THERAPEUTIC_TABLEHEAD}
                label="Therapeutic"
                fullScreenView={fullScreen}
                setFullScreenView={handleFullScreenGird1}
              />
            </>
          )}
        </>
        {gridDisplayMatrix.grid2Display && (
          <>
            {generalSystemParameterDetails?.[0]?.showSpecialTheraClassInd ===
              1 && (
              <>
                {!fullScreen && (
                  <span className="mt-3 col-12">
                    Alternate Therapeutic Class
                  </span>
                )}
                <TabNDCDetailsTableComponent
                  tableData={altTherapeutic}
                  label="Alternate Therapeutic"
                  tableHead={NDC_DETAILS_ALTERNATE_THERAPEUTIC_TABLEHEAD}
                  fullScreenView={fullScreen}
                  setFullScreenView={handleFullScreenGird2}
                />
              </>
            )}
          </>
        )}
      </div>

      <DisplayFamilyPlanning
        open={familyPlanning.open}
        data={familyPlanning.data}
        handleClose={handleCloseFamilyPlanning}
      />
    </>
  );
};

export default TabNDCDetail;
